import React from 'react';
import { Space } from 'antd';
import { useCurrentCitizen } from '../AuthModule';
import { Link, useHistory } from 'react-router-dom';
import { resolveApiPath } from 'client/core/appConfig';
import {
  useHasFeature,
  useSecurityStrategyConfig
} from 'client/components/schema/config/ClientConfigModule';
import { RoutePaths } from 'common/routes/RoutePaths';
import { useTranslation } from 'react-i18next';
import { LinkButton } from 'client/ui/link/LinkButton';
import { AnchorAPILink } from 'client/ui/link/AnchorAPILink';
import { SpaceProps } from 'antd/lib/space';

interface UserLoginButtonsProps extends SpaceProps {}

/**
 * Menu i pulsanti per l'accesso al portale per il cittadino.
 */
export function UserLoginButtons(props: UserLoginButtonsProps) {
  const citizen = useCurrentCitizen();
  const history = useHistory();
  const { t } = useTranslation();

  if (citizen) return null;

  // Ottiene informazioni sul login SPID (SAML)
  const samlConfig = useSecurityStrategyConfig('saml');
  // Ottiene informazioni sul login password-based
  const hasRegistration = useHasFeature('citizen.registration');

  return (
    <Space direction="vertical" style={{ width: '100%' }} {...props}>
      {samlConfig && (
        <AnchorAPILink
          showAsButton
          block
          size="large"
          type="primary"
          href={resolveApiPath('/auth/iam/sso')}
        >
          {samlConfig.loginButtonText ?? 'Accedi con SPID'}
        </AnchorAPILink>
      )}
      {hasRegistration && (
        <LinkButton
          block
          size="large"
          type="primary"
          to={{
            pathname: RoutePaths['/utente/login'],
            state: { from: history.location.pathname }
          }}
        >
          {t('menu.user-actions.login', 'Accedi')}
        </LinkButton>
      )}
    </Space>
  );
}
